import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Mail, Send, Check } from 'lucide-react';
import './Newsletter.css';

const Newsletter = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) return;

    setIsLoading(true);
    
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
      setEmail('');
      
      setTimeout(() => {
        setIsSubmitted(false);
      }, 3000);
    }, 1000);
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-container">
        <motion.div
          className="newsletter-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="newsletter-icon">
            <Mail size={48} />
          </div>
          
          <h2 className="newsletter-title">{t('newsletter.title')}</h2>
          <p className="newsletter-description">{t('newsletter.description')}</p>

          <form onSubmit={handleSubmit} className="newsletter-form">
            <div className="newsletter-input-wrapper">
              <Mail className="input-icon" size={20} />
              <input
                type="email"
                placeholder={t('newsletter.placeholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="newsletter-input"
                required
                disabled={isLoading || isSubmitted}
              />
            </div>
            
            <motion.button
              type="submit"
              className={`newsletter-button ${isSubmitted ? 'success' : ''}`}
              disabled={isLoading || isSubmitted}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isSubmitted ? (
                <>
                  <Check size={20} />
                  {t('newsletter.success')}
                </>
              ) : isLoading ? (
                <>
                  <div className="spinner"></div>
                  {t('newsletter.sending')}
                </>
              ) : (
                <>
                  <Send size={20} />
                  {t('newsletter.button')}
                </>
              )}
            </motion.button>
          </form>

          <p className="newsletter-privacy">{t('newsletter.privacy')}</p>
        </motion.div>

        <div className="newsletter-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
